<template>
    <div
        v-if="activeChatTemplatesTab"
        id="active-chat-templates"
        :class="{ show: activeChatTemplatesTab }"
        class="mx-1"
    >
        <b-tabs v-model="activeTabIndex" class="p-2" lazy pills>
            <span class="close-icon">
                <font-awesome-icon icon="times" @click="$emit('update:active-chat-templates-tab', '')" />
            </span>

            <b-tab :active="activeTabIndex === 0" :disabled="!resolveCustomerCareWindow">
                <template #title>
                    <font-awesome-icon icon="slash-forward" />
                    {{ $t("entities.quick-replies.Quick replies") }}
                </template>

                <quick-replies :active-chat="activeChat" @set-quick-reply="$emit('set-quick-reply', $event)" />
            </b-tab>
            <b-tab
                v-if="templatePlatforms.includes(activeChat.channel.platform.toUpperCase())"
                :active="activeTabIndex === 1"
            >
                <template #title>
                    <font-awesome-icon :icon="['fab', 'whatsapp']" />
                    {{ $t("platforms.WHATSAPP") }} {{ $t("entities.templates.approved-templates") }}
                </template>

                <approved
                    :active-chat="activeChat"
                    :selected-template="selectedTemplate"
                    @update:selected-template="$emit('update:selected-template', $event)"
                    @set-template="$emit('set-template', $event)"
                    @reset-template="$emit('reset-template')"
                />
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import {
    BAvatar,
    BAlert,
    BBadge,
    BNav,
    BNavItem,
    BListGroup,
    BListGroupItem,
    BCard,
    BCardText,
    BTabs,
    BTab,
} from "bootstrap-vue";

import QuickReplies from "./quickReplies";
import Approved from "./approved";
import Variables from "./variables.vue";
import { resolveRemainingCustomerCareWindow } from "@/utils/chats";
import { computed } from "@vue/composition-api";
import useActiveChatTemplates from "@/composables/useActiveChatTemplates";

export default {
    components: {
        BAvatar,
        BAlert,
        BBadge,
        BNav,
        BNavItem,
        BListGroup,
        BListGroupItem,
        BCard,
        BCardText,
        BTabs,
        BTab,

        QuickReplies,
        Approved,
        Variables,
    },
    props: {
        activeChatTemplatesTab: {
            type: String,
            required: true,
        },
        activeChat: {
            type: Object,
            required: true,
        },
        selectedTemplate: {
            type: Object,
            required: false,
        },
        channels: {
            type: Array,
            required: true,
        },
    },
    setup(props) {
        const { activeTabIndex } = useActiveChatTemplates(props.activeChat);
        const templatePlatforms = ["WHATSAPP", "TEST"];

        return {
            activeTabIndex,
            templatePlatforms,
            resolveCustomerCareWindow: computed(() =>
                resolveRemainingCustomerCareWindow(
                    props.activeChat.lastInboundMessageTime,
                    props.activeChat.channel?.customerCareWindowLength
                )
            ),
        };
    },
};
</script>

<style lang="scss">
@import "~@/assets/scss/components/inbox/activeChatTemplates.scss";
</style>
